import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BorrowerDTO } from 'src/app/models/borrower/borrower-dto';

@Injectable({
  providedIn: 'root'
})
export class DlpUtilityService {

  constructor() { }

  createFormError(formGroup: FormGroup) {
    let formErrors: any = {};
    let controls = formGroup.getRawValue();
    Object.keys(controls).forEach(control => {
      formErrors[control] = '';
    })
    return formErrors;
  }

  isValidObject(obj) {
    if (obj) {
      return true;
    }
    return false;
  }

  isValidArray(arr) {
    if (arr && arr.length > 0) {
      return true;
    }
    return false;
  }

  copyObject(obj: any) {
    let copyObj: any;
    let keyArr = Object.keys(obj);
    keyArr.forEach(key => {
      if (this.isValidArray(obj[key])) {
        copyObj[key] = [...obj[key]];
      }
      else if (this.isValidObject(obj[key])) {
        copyObj[key] = obj[key];
      }

    })
    return copyObj;
  }

  copyArray(arr: any[]) {
    let copyArr: any[] = [];
    if (this.isValidArray(arr)) {
      for (let i = 0; i < arr.length; i++) {
        copyArr[i] = arr[i];
      }
    }
    return copyArr;
  }

  decode(value: string): string {
    return atob(value);
  }

  encode(value: string): string {
    return btoa(value);
  }

  encodeFinder(obj, value):string {
    for (var key in obj) {
      // console.log(key);
      if (this.decode(key) == value) {
        return this.decode(key);
      }
    }
    return "";
  }

}
